import { Spinner } from '../Spinner/Spinner'

export function AppLoader() {
  return (
    <div className='flex flex-col items-center justify-center min-h-screen'>
      <Spinner />
    </div>
  )
}
